// extracted by mini-css-extract-plugin
module.exports = {"addProductButton":"styles_addProductButton__111wW","addProductButtonContainer":"styles_addProductButtonContainer__1csvy"};